module.exports = __webpack_public_path__ + "assets/img/编组 8-min.42501011.png";